export const callsPath = () => "/calls";
